import React, { Component } from "react";
import { Div, Text, Input, Button, Image } from "atomize";
import InnerHTML from "../../utilities/innerHtml";
import WebsiteContainer from "../common/WebsiteContainer";
import CustomContainer from "../common/CustomContainer";
import ImageLink from "../common/ImageLink";
import { IsValidUrl, updateActiveCampaignForm } from "../../utilities/helpers";
import SolutionsPagesButton from "../common/SolutionsPagesButtons";

export default class EngagementHero extends Component {
  render() {
    const { content, form } = this.props;

    return (
      <Div p={{ b: "9rem" }}>
        <Div className="solutions-gradient-hero">
          <WebsiteContainer>
            <CustomContainer>
              <Div
                textAlign="center"
                p={{ t: "4.75rem" }}
                className="solutions"
              >
                <Text
                  textSize={{ xs: "title2", md: "display2" }}
                  className="hero-text"
                  textWeight="700"
                  maxW="30rem"
                  m="auto"
                  tag="h1"
                >
                  {content.heading}
                </Text>
                <Text
                  maxW="38rem"
                  m=".7rem auto"
                  textSize={{ xs: "17px", md: "paragraph" }}
                  style={{ lineHeight: "30px" }}
                >
                  {content.text}
                </Text>
                <Div maxW="24.2rem" m="1.7rem auto">
                  {/* {typeof window !== "undefined" && (
                    <InnerHTML html={updateActiveCampaignForm(form)} />
                  )} */}
                  <SolutionsPagesButton
                    bgColor="primary"
                    hoverBgPrimary="#FFCB6F"
                    textColor="black"
                  />
                </Div>
              </Div>
            </CustomContainer>
          </WebsiteContainer>
          <ImageLink link="">
            <Div
              bgImg="/images/engagement-rates-hero-bg.svg"
              d={{ xs: "none", md: "block" }}
              bgSize="contain"
              bgPos="right bottom"
              bgRepeat="no-repeat"
              textAlign="center"
              m={{ t: "1rem" }}
            >
              <WebsiteContainer>
                <CustomContainer>
                  <ImageLink link="">
                    <Div
                      bgImg={content.imgPC}
                      d={{ xs: "none", md: "block" }}
                      bgSize="cover"
                      p={{ b: "32%" }}
                      bgPos="center"
                      bgRepeat="no-repeat"
                      textAlign="center"
                      m={{ t: "1rem" }}
                    ></Div>
                  </ImageLink>
                </CustomContainer>
              </WebsiteContainer>
            </Div>
          </ImageLink>
          <ImageLink link="">
            <Div
              bgImg={content.imgMobile}
              d={{ xs: "block", md: "none" }}
              bgSize="cover"
              p={{ b: "75.8%" }}
              bgPos="center"
              bgRepeat="no-repeat"
              textAlign="center"
              m={{ t: "2rem" }}
            ></Div>
          </ImageLink>
        </Div>
      </Div>
    );
  }
}
